import { render, staticRenderFns } from "./GroupsFeed.vue?vue&type=template&id=65edbbd4&"
import script from "./GroupsFeed.vue?vue&type=script&lang=js&"
export * from "./GroupsFeed.vue?vue&type=script&lang=js&"
import style0 from "./GroupsFeed.vue?vue&type=style&index=0&id=65edbbd4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports